// styles/reportStyles.js
import { makeStyles } from "@mui/styles";

// Remove theme parameter since it's not being used in the styles that are causing the error
export const useReportStyles = makeStyles(() => ({
  root: {
    "& .super-app-theme--header": {
      position: "sticky",
      left: 0,
      backgroundColor: "#0c367a",
      color: "#fff",
      zIndex: 1,
    },
    "& .super-app-theme--cell": {
      position: "sticky",
      left: 0,
      backgroundColor: "#fff",
      zIndex: 1,
    },
  },
  
  // Form control styles
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "45px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
      {
        padding: "11.5px 14px",
      },
  },

  // Select styles
  select: {
    width: "auto",
    fontSize: "12px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  
  selectIcon: {
    position: "relative",
    color: "#6EC177",
    fontSize: "14px",
  },
  
  // Paper styles for popovers
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
  
  // List styles
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: 200,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: "12px",
    },
    "& li.Mui-selected": {
      color: "white",
      background: "#6EC177",
    },
    "& li.Mui-selected:hover": {
      background: "#6EC177",
      border: "1px solid #fff",
    },
  },

  // Date picker styles
  datePicker: {
    "& .rdtPicker": {
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    },
    "& input": {
      height: "32px",
      padding: "6px 10px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "1px solid #e0e0e0",
      "&:focus": {
        borderColor: "#1976d2",
        outline: "none",
      },
    },
  },

  // Table header styles
  tableHeader: {
    backgroundColor: "#0c367a",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "12px",
    "& th": {
      color: "#fff",
      fontWeight: 600,
      fontSize: "13px",
    },
  },

  // Table cell styles
  tableCell: {
    padding: "8px",
    fontSize: "13px",
    borderBottom: "1px solid #e0e0e0",
  },

  // Caller ID link styles
  callerIdLink: {
    color: "#2563eb",
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: 600,
    "&:hover": {
      color: "#1d4ed8",
    },
  },

  // Status badge styles
  statusBadge: {
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: 500,
    display: "inline-block",
  },
  statusAnswered: {
    backgroundColor: "#d1fae5",
    color: "#065f46",
  },
  statusMissed: {
    backgroundColor: "#fed7aa",
    color: "#9a3412",
  },
  statusFailed: {
    backgroundColor: "#fee2e2",
    color: "#991b1b",
  },

  // Button styles
  searchButton: {
    backgroundColor: "#10b981 !important",
    color: "#fff !important",
    height: "43px",
    "&:hover": {
      backgroundColor: "#059669 !important",
    },
  },
  
  resetButton: {
    backgroundColor: "#6b7280 !important",
    color: "#fff !important",
    height: "43px",
    "&:hover": {
      backgroundColor: "#4b5563 !important",
    },
  },
  
  blockButton: {
    height: "43px",
    color: "#fff !important",
    "&:disabled": {
      backgroundColor: "#9ca3af !important",
    },
  },

  // Modal styles
  modalTitle: {
    color: "#0a140e",
    fontSize: "20px",
    fontWeight: 600,
    marginLeft: "20px",
  },

  modalSectionTitle: {
    fontWeight: 600,
    fontSize: "18px",
    marginBottom: "10px",
  },

  modalLabel: {
     width: "40%",
  wordBreak: "break-word",
    border: "none",
    fontSize: "13px",
    padding: "7px",
    fontWeight: 700,
    color: "#07285d",
  },

  modalValue: {
       width: "60%",
  wordBreak: "break-word",
    border: "none",
    fontSize: "13px",
    padding: "6px",
  },

  // Table container
  tableContainer: {
    borderRadius: "12px",
    overflowX: "auto",
    maxWidth: "100%",
  },

  // Audio player styles
  audioPlayer: {
    paddingRight: "4px",
    width: "100%",
    height: "28px",
     maxWidth: "220px",
  },
}));

// Additional style constants
export const colorStyles = {
  dateBlue: {
    color: "blue",
    fontSize: "12.215px",
  },
  timeGreen: {
    color: "green",
    fontSize: "12.215px",
  },
  callerIdBlue: {
    color: "#2563eb",
  },
};

// CSS classes as strings for global styles
export const globalStyles = `
  .filter_search_btn {
    background-color: #10b981 !important;
    color: white !important;
  }
  .filter_search_btn:hover {
    background-color: #059669 !important;
  }
  
  .filter_reset_btn {
    background-color: #6b7280 !important;
    color: white !important;
  }
  .filter_reset_btn:hover {
    background-color: #4b5563 !important;
  }
  
  .filter_block_btn {
    background-color: #ef4444 !important;
    color: white !important;
  }
  .filter_block_btn:hover {
    background-color: #dc2626 !important;
  }
  
  .datefield_select input {
    height: 32px;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    width: 100%;
  }
  
  .datefield_select input:focus {
    border-color: #1976d2;
    outline: none;
  }
  
  .custom_header_redirect .MuiDataGrid-columnHeaders {
    background-color: #0c367a !important;
    color: white !important;
  }
  
  .close_icon {
    float: inline-end;
  }
  
  .callaudio {
    width: 100%;
    height: 28px;
  }
`;

// Remove the responsive section that was using theme.breakpoints
// If you need responsive styles, create separate style objects

// Responsive style helpers (without using theme)
export const responsiveStyles = {
  hideOnMobile: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  fullWidthOnMobile: {
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  audioPlayerMobile: {
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
};

// Export all styles
export default useReportStyles;